export default {
  fields: ['firstName', 'lastName', 'email', 'contactNumber'],
  rules: {
    firstName: [{ rule: 'isRequired', message: 'First name is required' }],
    lastName: [{ rule: 'isRequired', message: 'Last name is required' }],
    email: [{ rule: 'isEmail', message: 'Email is invalid' }],
    contactNumber: [{ rule: 'isPhone', message: 'Contact number is invalid' }],
  },
};
